import { AlertTriangle } from "lucide-react";

/**
 * Persistent liability banner shown on EVERY quiz/exam/lesson screen.
 * Wording is deliberate — the platform is prep material, not the official
 * Transport Canada exam.
 */
export function PracticeBanner({ variant = "default", testid = "practice-banner" }) {
  const cls = variant === "exam" ? "tbg-practice-banner tbg-practice-banner--exam" : "tbg-practice-banner";
  return (
    <div className={cls} data-testid={testid} role="note">
      <AlertTriangle size={14} strokeWidth={2.4} />
      <span className="lbl">Practice Material</span>
      <span className="txt">
        Preparation only — this is <b>not</b> the official Transport Canada Small Advanced Exam.
        The real exam is written on the TC Drone Management Portal.
      </span>
    </div>
  );
}
